import api from "./api";
import { AppResponse } from "../models/common/app-response";
import { PaginatedResponse } from "../models/common/paginated-response";
import { WaybillsFilter } from "../models/waybills/waybillsFilter";
import { WaybillsTableRowDto } from "../models/waybills/waybillsTableRowDto";
import { WaybillHashDto, WaybillPhysicalSignDto, WaybillSignPayloadDto } from "../models/waybills/waybillSignDto";

class WaybillsService {
    baseUrl = "/api/v1/waybills";

    getByFilter = (filter: WaybillsFilter) => {
        return api.post<AppResponse<PaginatedResponse<WaybillsTableRowDto>>>(`${this.baseUrl}/filter`, filter);
    };

    signWithCloudToken = (waybillId: number, dto: WaybillSignPayloadDto) => {
        return api.post<AppResponse<boolean>>(`${this.baseUrl}/${waybillId}/verdict/cloud-token`, dto);
    };

    createHash = (waybillId: number, dto: WaybillSignPayloadDto) => {
        return api.post<AppResponse<WaybillHashDto>>(`${this.baseUrl}/${waybillId}/hash`, dto)
            .then(x => x.data.data);
    };

    signWithPhysicalToken = (waybillId: number, dto: WaybillPhysicalSignDto) => {
        return api.post<AppResponse<boolean>>(`${this.baseUrl}/${waybillId}/verdict/physical-token`, dto);
    };
}

export const waybillsService = new WaybillsService();
